import React from 'react';
import './partnersItem.scss';

export const PartnersItem = (props) => {
  return (
    <div className="partnerLogo_div">
      <img
        src={props.partnerLogo}
        alt={props.partnerAlt}
        className="partnerLogo"
      />
    </div>
  );
};
